import React from 'react';

const GoalItemContent = ({ goal }) => (
  <div className="flex flex-col justify-center items-start">
    <div className="font-semibold mb-2 text-left">{goal.summary}</div>
  </div>
);

const CriticalElementsList = ({ elements }) => {
  if (!elements.length) {
    return null;
  }

  return (
    <div className="mt-4">
      <div className="font-semibold text-sm mb-2">Critical Elements</div>

      <ul className="list-disc pl-5 text-gray-04">
        {elements.map((element, index) => (
          <li key={index} className="text-sm mb-1">
            {element.summary}
          </li>
        ))}
      </ul>
    </div>
  );
};

const GoalItem = ({ goal }) => (
  <div className="bg-gray-00 px-5 py-4 rounded-md w-72 min-h-28 flex flex-col border border-navy-01">
    {goal.category === 'Other' ? (
      <div className="flex flex-col justify-center items-start">
        <div className="font-semibold text-left">{goal.name}</div>
      </div>
    ) : (
      <GoalItemContent goal={goal} />
    )}
    <CriticalElementsList elements={goal.criticalElements} />
  </div>
);

export default GoalItem;
